/**
 * Blockchain Configuration
 *
 * PeopleTag runs on Arc Testnet (Circle).
 */

export const ARC_CONTRACT_ADDRESS = '0x36014Af11c60FbbB2Db7EF7E419E40201dC43fFe';

// Arc Testnet (Circle)
export const ARC_TESTNET_NETWORK = {
  chainId: '0x4CEF52', // 5042002
  chainIdDecimal: 5042002,
  name: 'Arc Testnet',
  rpcUrl: 'https://rpc.testnet.arc.network',
  blockExplorer: 'https://testnet.arcscan.app',
  // MetaMask's wallet_addEthereumChain (EIP-3085) requires decimals === 18.
  // Arc's gas token is USDC (6 decimals), but MetaMask rejects anything other
  // than 18 here. Keep this at 18 for the network add; use USDC_DECIMALS for
  // actual token amount math.
  nativeCurrency: {
    name: 'USD Coin',
    symbol: 'USDC',
    decimals: 18
  },
  contractAddress: ARC_CONTRACT_ADDRESS
};

// Arc's native USDC is exposed at the wei level with 18 decimals (matching
// MetaMask's nativeCurrency requirement above), so provider.getBalance and
// tx.value both operate in 18-decimal wei. Use this for formatUnits/parseUnits.
export const USDC_DECIMALS = 18;

export const DEFAULT_NETWORK = ARC_TESTNET_NETWORK;
